import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import legacyUrlRedirects from './legacyUrlRedirects.json';

/**
 * Resolves old bookmarked URLs listed in legacyUrlRedirects.json.
 * Add an entry there once if you rename paths; remove entries when traffic dies off.
 */
export default function LegacyUrlRedirect() {
  const { pathname, search } = useLocation();

  for (const rule of legacyUrlRedirects) {
    const from = String(rule.from || '');
    const to = String(rule.to || '');
    if (!from || !to || !pathname.startsWith(from) || pathname.length <= from.length) {
      continue;
    }
    const rest = pathname.slice(from.length);
    return <Navigate to={`${to}${rest}${search}`} replace />;
  }

  return <Navigate to="/404" replace />;
}

/** First path segment for each legacy prefix — used to register splat routes. */
export function legacyRedirectRoutePaths() {
  const paths = new Set();
  for (const rule of legacyUrlRedirects) {
    const segment = String(rule.from || '')
      .split('/')
      .filter(Boolean)[0];
    if (segment) paths.add(`/${segment}/*`);
  }
  return [...paths];
}
